import {createApp} from 'vue'
import App from './App.vue'
import './index.css'
import router from './router'
import '@stripe/stripe-js'
import AudioVisual from 'vue-audio-visual'

createApp(App).use(router).use(AudioVisual).mount('#app') 
